import { Component, Input, Output, OnInit, ViewChild, EventEmitter, OnChanges, AfterViewChecked } from '@angular/core';
import { IMAGEVIEWER_CONFIG, ImageViewerConfig } from '@hallysonh/ngx-imageviewer';
import { CHttp } from '../services/chttp.service';
import { config } from '../../app.config';
import { AuthDataStorageService } from '../../auth/services/auth-data-storage.service';
import { RequestNewIdReason, NewProofSelectOption, newProofSelectOptions } from '../../member/members.interfaces';

declare var jQuery: any;

const MY_IMAGEVIEWER_CONFIG: ImageViewerConfig = {
  width: 566,
  height: 477,
  buttonStyle: {
    bgStyle: '#B71C1C' // custom container's background style
  }
};

@Component({
  selector: 'ch-member-preview-modal-dialog',
  templateUrl: './member-preview-modal-dialog.component.html',
  styleUrls: ['./member-preview-modal-dialog.component.css'],
  providers: [
    {
      provide: IMAGEVIEWER_CONFIG,
      useValue: MY_IMAGEVIEWER_CONFIG
    }
  ]
})
export class MemberPreviewModalDialogComponent implements OnInit, OnChanges, AfterViewChecked {
  @Input() public show: boolean;
  @Input() public data: any;
  @Output() public close: EventEmitter<any> = new EventEmitter();
  @Output() public actionSelected: EventEmitter<RequestNewIdReason | string> = new EventEmitter();
  @ViewChild('modal') private modal;
  public resourceId: string;
  public resourceUrl: string;
  public fileType: string;
  public loading: boolean;
  public src: string;
  public reasons: NewProofSelectOption[] = newProofSelectOptions();
  public selectReasonValue: any;

  public selectForm = {
    selectValue: null
  };

  private change: boolean;

  constructor(private http: CHttp, private authDataStorageService: AuthDataStorageService) { }

  ngOnInit() { }

  ngOnChanges() {
    this.selectForm = {
      selectValue: null
    };

    if (this.show) {
      this.change = true;
    }
    this.resourceId = this.data ? this.data.resourceId : '';
    this.resourceUrl = `${config.api_url}resources/${this.resourceId}?x-auth-token=${this.authDataStorageService.getSessionTokenFromStorage()}`;

    if (this.show) {
      this.loading = true;
      this.http.get(this.resourceUrl).subscribe(resp => {
        this.fileType = this.isImage(resp.headers.get('Content-Type'))
          ? 'image'
          : this.isPdf(resp.headers.get('Content-Type'))
            ? 'pdf'
            : 'other';
        this.src = this.resourceUrl;

        this.loading = false;
      });
    }
  }

  private isImage(name) {
    return name.toLowerCase().match("^image/[a-zA-Z0-9_]*") !== null;
  }

  private isPdf(name) {
    return name.toLowerCase().match("application/pdf") !== null;
  }

  public downloadProof() {
    const a = document.createElement("a");
    a.href = this.resourceUrl;
    a.download = this.resourceUrl.split("/").pop();
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  ngAfterViewChecked() {
    if (this.change) {
      jQuery(this.modal.nativeElement)
        .modal({
          backdrop: false
        })
        .on('hidden.bs.modal', e => {
          this.close.emit(e);
        });

      this.change = false;
    }
  }

  public accept() {
    this.actionSelected.emit('accept');
    this.closeDialog();
  }

  public requestNewId(value: RequestNewIdReason) {
    this.actionSelected.emit(value);
    this.closeDialog();
  }

  public reject() {
    this.actionSelected.emit('reject');
    this.closeDialog();
  }

  private closeDialog() {
    jQuery(this.modal.nativeElement).modal('hide');
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/member-preview-modal-dialog/member-preview-modal-dialog.component.ts